module.exports = __webpack_public_path__ + "static/wechat-qrcode-95cf31fde2e827cc468a44fb7b09dfaf.jpg";